import angular from 'angular'

import deline from './deline'
import envRaw from './env-raw'
import Emitter from './emitter'
import forceResize from './force-resize'
import extractRawElm from './extract-raw-elm'
import ResizeDetector from './resize-detector'

angular
  .module('ggs.utils')
  .factory('rootResize', rootResizeProvider)

function rootResizeProvider(
  $log,
  $rootScope,
  $rootElement) {

  // define rootResize
  const rootResize = Emitter('rootResize')

  rootResize.width = Emitter('rootResize::width')
  rootResize.height = Emitter('rootResize::height')

  let lastWidth = null
  let lastHeight = null

  // subscribe rootResize
  const rootElm = extractRawElm($rootElement)
  const resizeDetector = ResizeDetector(rootElm)
  resizeDetector.on(handler)
  resizeDetector.ignoreForceResizeEvents()
  forceResize.emitter.on(manualTrigger)

  // export
  rootResize.getWidth = getWidth
  rootResize.getHeight = getHeight
  rootResize.manualTrigger = manualTrigger

  // destroy
  $rootScope.$on('$destroy', () => {
    resizeDetector.off(handler)
    forceResize.emitter.off(manualTrigger)
  })

  return rootResize

  function getWidth() {
    return resizeDetector.getWidth()
  }

  function getHeight() {
    return resizeDetector.getHeight()
  }

  function manualTrigger() {
    lastWidth = null
    lastHeight = null
    resizeDetector.manualTrigger()
  }

  function handler(rootWidth, rootHeight) {
    const widthChanged = rootWidth !== lastWidth
    const heightChanged = rootHeight !== lastHeight
    const someChanged = widthChanged || heightChanged

    if (widthChanged) lastWidth = rootWidth
    if (heightChanged) lastHeight = rootHeight

    if (someChanged) rootResize.emit(lastWidth, lastHeight)
    if (widthChanged) rootResize.width.emit(lastWidth, lastHeight)
    if (heightChanged) rootResize.height.emit(lastWidth, lastHeight)

    if (envRaw.showsRootResizeDebug) {
      $log.force.debug(deline(`
        ${Date.now()} !rootResize
          [${widthChanged ? 'W' : '-'}]
          [${heightChanged ? 'H' : '-'}]:
          { width: ${lastWidth}, height: ${lastHeight} }`))
    }
  }
}
